<template>
  <div>
    <Header class="header">
      <Menu mode="horizontal" theme="light" :active-name="this.$route.name">
        <template v-if="resourceAccess">
          <MenuItem class="menu-item" to="/manage/videos" name="videos">{{$t('manage.videos.stations')}}</MenuItem>
          <MenuItem class="menu-item" to="/manage/books" name="books">{{$t('manage.resources.appBooks')}}</MenuItem>
          <MenuItem class="menu-item" to="/manage/resources" name="resources">{{$t('manage.resources.title')}}</MenuItem>
          <MenuItem class="menu-item" to="/manage/facilitator" name="facilitator">{{$t('manage.resources.facilitator')}}</MenuItem>
          <MenuItem class="menu-item" to="/manage/manuals" name="manuals">{{$t('manage.manuals.title')}}</MenuItem>
          <MenuItem class="menu-item" to="/manage/entrepreneurship" name="entrepreneurship">{{$t('manage.resources.entrepreneurship')}}</MenuItem>
          <MenuItem class="menu-item" to="/manage/printouts" name="setup">{{$t('manage.resources.printouts')}}</MenuItem>
          <MenuItem class="menu-item" to="/manage/setup" name="setup">{{$t('manage.resources.setup')}}</MenuItem>
          <MenuItem class="menu-item" to="/manage/hotspot" name="hotspot">{{$t('manage.resources.hotspot')}}</MenuItem>
        </template>
        <MenuItem class="menu-item" to="/manage" name="manage">{{$t('manage.licenseInfo')}}</MenuItem>
      </Menu>
    </Header>
    <Layout class="manage">
      <Sider class="sider" :width="200">
        <Menu class="menu" :active-name="this.$route.name" theme="light" width="auto">
          <template v-if="resourceAccess">
            <MenuItem class="menu-item" to="/manage/videos" name="videos">{{$t('manage.videos.stations')}}</MenuItem>
            <MenuItem class="menu-item" to="/manage/books" name="books">{{$t('manage.resources.appBooks')}}</MenuItem>
            <MenuItem class="menu-item" to="/manage/resources" name="resources">{{$t('manage.resources.title')}}</MenuItem>
            <MenuItem class="menu-item" to="/manage/facilitator" name="facilitator">{{$t('manage.resources.facilitator')}}</MenuItem>
            <MenuItem class="menu-item" to="/manage/manuals" name="manuals">{{$t('manage.manuals.title')}}</MenuItem>
            <MenuItem class="menu-item" to="/manage/entrepreneurship" name="entrepreneurship">{{$t('manage.resources.entrepreneurship')}}</MenuItem>
            <MenuItem class="menu-item" to="/manage/printouts" name="printouts">{{$t('manage.resources.printouts')}}</MenuItem>
            <MenuItem class="menu-item" to="/manage/setup" name="setup">{{$t('manage.resources.setup')}}</MenuItem>
            <MenuItem class="menu-item" to="/manage/hotspot" name="hotspot">{{$t('manage.resources.hotspot')}}</MenuItem>
          </template>
          <MenuItem class="menu-item" to="/manage" name="manage">{{$t('manage.licenseInfo')}}</MenuItem>
        </Menu>
      </Sider>
      <keep-alive>
        <router-view class="main-view"></router-view>
      </keep-alive>
    </Layout>
  </div>
</template>

<script>
import {mapState} from 'vuex';

export default {
  mounted() {
    if (!this.isLoggedIn) {
      this.$router.replace('/');
    } else if (this.resourceAccess) {
      this.$router.replace('/manage/videos');
    }
  },
  computed: {
    ...mapState({
      isLoggedIn: state => state.license.isLoggedIn,
      license: state => state.license.license,
      resourceAccess: state => state.license.license && ((state.license.license.type & 4) > 0)
    }),
  },
  data() {
    return {

    }
  }
}
</script>

<style lang="scss">
.main-view {
  padding: 0 200px 0 300px;

  @include respond-to(phone) {
    padding: 0 10px;
  }
  @include respond-to(tablet) {
    padding: 0 10px;
  }


  .ivu-card {
    font-size: 20px !important;
  }
}
.sider {
  .ivu-menu-item {
    font-size: 18px;

    @include respond-to(phone) {
      font-size: 12px;
    }
    @include respond-to(tablet) {
      font-size: 12px;
    }
  }
}
</style>

<style scoped lang="scss">
.manage {
  padding: 0 150px;

  @include respond-to(phone) {
    padding: 0;
  }

  @include respond-to(tablet) {
    padding: 0 10px;
  }
}
.header {
  padding: 0;

  @include respond-to(large) {
    display: none;
  }

  .ivu-menu {
    overflow-x: scroll;
    white-space: nowrap;
    box-sizing: border-box;
    overflow-y: hidden;

    &.ivu-menu-horizontal {
      height: unset;
      line-height: unset;
    }

    .ivu-menu-item {
      float: none;
      display: inline-block;
    }
  }
}
.sider {
  padding: 40px 10px;
  background: transparent !important;
  white-space:  nowrap;
  overflow-x: visible;
  position: absolute;

  @include respond-to(phone) {
    display: none;
  }
  @include respond-to(tablet) {
    display: none;
  }

  .menu {
    background: transparent;

    &:after {
      background: none !important;
    }

    .menu-item {
      background: transparent;
      padding: 8px 24px;
    }

    .ivu-menu-item-active {
      font-weight: 600;
      background: transparent !important;

      &:after {
        background: none !important;
      }
    }
  }
}
</style>